import { render, staticRenderFns } from "./MoreMobilePackages.vue?vue&type=template&id=02f99968"
import script from "./MoreMobilePackages.vue?vue&type=script&lang=js"
export * from "./MoreMobilePackages.vue?vue&type=script&lang=js"
import style0 from "./MoreMobilePackages.vue?vue&type=style&index=0&id=02f99968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports